import { render, staticRenderFns } from "./P2.vue?vue&type=template&id=0f8ae4bf&scoped=true"
import script from "./P2.vue?vue&type=script&lang=js"
export * from "./P2.vue?vue&type=script&lang=js"
import style0 from "./P2.vue?vue&type=style&index=0&id=0f8ae4bf&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f8ae4bf",
  null
  
)

export default component.exports